module.exports = __webpack_public_path__ + "img/AverageIcon.943bd248.svg";